import { getLocalizedValue } from '@grandvisionhq/utils';
import { isExtraType } from '../types/typeguards.js';

const mapLensExtraProductsToExtrasItems = (lensExtraProducts, locale)=>{
    const monofocalExtras = lensExtraProducts.filter((item)=>isExtraType(item.slug.en) && item.masterVariant.prices && item.masterVariant.prices.length
    ).map((item)=>{
        // @ts-ignore, is checked in the filter above
        const price = item.masterVariant.prices[0].value.centAmount;
        return {
            title: getLocalizedValue(item.name, locale),
            text: item.description ? getLocalizedValue(item.description, locale) : '',
            value: item.slug.en,
            price,
            disabled: false
        };
    });
    const multifocalExtras = lensExtraProducts.filter((item)=>item.variants.length !== 0 && item.variants[0].prices && item.variants[0].prices.length && isExtraType(item.slug.en)
    ).map((item)=>{
        // @ts-ignore, is checked in the filter above
        const price = item.variants[0].prices[0].value.centAmount;
        return {
            title: item.name ? getLocalizedValue(item.name, locale) : '',
            text: item.description ? getLocalizedValue(item.description, locale) : '',
            value: item.slug.en,
            price,
            disabled: false
        };
    });
    return {
        monofocalExtras,
        multifocalExtras
    };
};

export { mapLensExtraProductsToExtrasItems };
//# sourceMappingURL=map-lens-extra-products-to-extras-items.js.map
